export const RED = "#d32f2f";
const LINE = "#ef9a9a";
const pad = (n) => String(n).padStart(2, "0");
export const dmy = (d) => `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
export const stamp = (d) => `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
export const money = (n) => `₹${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const phone = (p) => { const d = (p || "").replace(/\D/g, "").slice(-10); return d.length === 10 ? `${d.slice(0, 5)} ${d.slice(5)}` : p; };
export const cell = { borderColor: LINE };

export function Rich({ text, tokens = {}, className = "", testid }) {
  const lines = (text || "").replace(/\{\{(\w+)\}\}/g, (m, k) => tokens[k] ?? m).split("\n");
  return (
    <div className={className} data-testid={testid}>
      {lines.map((l, i) => {
        if (!l.trim()) return <div key={i} className="h-2" />;
        const bullet = l.startsWith("- ");
        const m = !bullet && l.match(/^([^:]{2,45}):(.*)$/);
        return <p key={i} className={/^\d+\.\s/.test(l) ? "font-semibold mt-2" : bullet ? "pl-3" : ""}>{m ? <><b>{m[1]}:</b>{m[2]}</> : l}</p>;
      })}
    </div>
  );
}

export function Box({ title, children, testid, className = "" }) {
  return (
    <div className={`border ${className}`} style={{ borderColor: RED }} data-testid={testid}>
      {title && <div className="text-center py-1.5 text-[15px] border-b" style={{ borderColor: RED, color: RED }}>{title}</div>}
      {children}
    </div>
  );
}

export function LabelRows({ rows, labelRed }) {
  return rows.map((r, i) => (
    <div key={i} className="grid grid-cols-[150px_1fr] border-b last:border-b-0 text-[11px]" style={cell}>
      <div className={`px-2 py-1 border-r ${labelRed ? "font-semibold" : ""}`} style={{ ...cell, color: labelRed ? RED : undefined }}>{r.label}</div>
      <div className={`px-2 py-1 whitespace-pre-line ${labelRed ? "font-semibold" : ""}`}>{r.value}</div>
    </div>
  ));
}
